import script from "./device-statistics.vue?vue&type=script&lang=ts&setup=true"
export * from "./device-statistics.vue?vue&type=script&lang=ts&setup=true"

import "./device-statistics.vue?vue&type=style&index=0&id=35699993&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35699993"]])

export default __exports__